module.exports = (__parcel__import__("jGOz3")).then(() => parcelRequire('GLD9c'));